<section class="db-ecommerce-menu-sidebar-items-wrapper">
  <div class="sidebar-menu-types-container" *ngIf="!activeType; else activeTypeContainer">
    <div class="sidebar-menu-type"
         (click)="setActiveType(type)"
         *ngFor="let type of types">
      <span class="sidebar-menu-type-title">{{type.title === 'Product tags' ? 'Collection' : type.title}}</span>
      <i class="db-icon db-icon-ds-arrow-right"></i>
    </div>
  </div>
  <ng-template #activeTypeContainer>
    <div class="sidebar-menu-type-item-back-btn" (click)="backToTypes()">
      <i class="db-icon db-icon-ds-arrow-small"></i>
      <span class="ml8">{{ 'text_back' | dbText }}</span>
    </div>
    <ng-container *ngIf="!showCreateCustom; else createCustom">
      <div class="sidebar-menu-type-item-container"
           *ngIf="selectedTypeItems.length; else emptyBlock">
        <div class="sidebar-menu-type-item"
             (click)="addNewMenuItem.emit(item)"
             *ngFor="let item of selectedTypeItems">
          <span class="sidebar-menu-type-item-title">
            {{item.title}}
          </span>

          <div class="add-menu-item-container">
            <i class="db-icon db-icon-ds-add"></i>
          </div>
        </div>
      </div>
      <ng-template #emptyBlock>
        <div class="empty-block">
          {{ 'text_youDontHaveAnyItemsInThisSection' | dbText }}
        </div>
      </ng-template>
    </ng-container>

    <ng-template #createCustom>
      <div class="db-ecommerce-menu-sidebar-create-custom"
           [formGroup]="menuItemForm">
        <div class="custom-link-field-container mt17">
          <div class="required-field-label">
            <span>
              {{ 'text_url' | dbText }}
              <span [class.invalid]="false"
                    class="required-mark">
                *
              </span>
            </span>
          </div>
          <input class="ds-input"
                 type="text"
                 [ngClass]="{'error': menuItemForm.get('url').invalid && menuItemForm.get('url').touched}"
                 formControlName="url"
                 placeholder="www.example.com">
          <div class="field-invalid-message"
               *ngIf="menuItemForm.get('url').touched && menuItemForm.get('url').hasError('required')">
            {{ 'text_urlIsRequired' | dbText }}
          </div>
          <div class="field-invalid-message"
               *ngIf="menuItemForm.get('url').touched && menuItemForm.get('url').hasError('pattern')">
            {{ 'text_inputCorrectUrl' | dbText }}
          </div>
        </div>
        <div class="custom-link-field-container mt30">
          <div class="required-field-label">
            <span>{{ 'text_navigationLabel' | dbText }}
              <span [class.invalid]="false"
                    class="required-mark">
                *
              </span>
            </span>
          </div>
          <input class="ds-input"
                 type="text"
                 [ngClass]="{'error': menuItemForm.get('navigationLabel').invalid && menuItemForm.get('navigationLabel').touched}"
                 formControlName="navigationLabel"
                 [placeholder]="'text_exContactUs' | dbText">
          <div class="field-invalid-message"
               *ngIf="menuItemForm.get('navigationLabel').touched && menuItemForm.get('navigationLabel').invalid">
            {{ 'text_nameIsRequired' | dbText }}
          </div>
        </div>
        <button class="ds-btn-black mt30"
                (click)="addCustomItem()"
                [class.ds-btn-disabled]="menuItemForm.invalid">
          {{ 'text_addItem' | dbText }}
        </button>
      </div>
    </ng-template>
  </ng-template>
</section>
